import { validStartDate } from './dates';

export const applicationStartDateValidator = (application: Application) => ({
  ...application,
  policyStartDate: validStartDate(application.policyStartDate),
});
